import { PhysicianActions } from 'src/redux/actions/constant';
import {
  PhysicianDocument,
  DocumentSignatureWorkflowStatuses,
} from 'src/services/apiServices/physician-service/physician-service';

const {
  UPDATE_DOCUMENT_STATUSES_SUCCESS,
  UPDATE_DOCUMENT_STATUSES_FAILURE,
  UPDATE_DOCUMENT_STATUSES_RESET,
} = PhysicianActions;

interface updateDocumentStatusesState {
  isUpdateSuccess: boolean;
  response: any;
  physicianId: string;
  physicianDocumentUuids: PhysicianDocument['uuid'][];
  physicianSignatureStatus: DocumentSignatureWorkflowStatuses;
  physicianSignature: string | null;
}

const initialState: updateDocumentStatusesState = {
  isUpdateSuccess: false,
  response: null,
  physicianId: '',
  physicianDocumentUuids: [],
  physicianSignatureStatus: 'PENDING_APPROVAL',
  physicianSignature: null,
};

export const updateDocumentStatusesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case UPDATE_DOCUMENT_STATUSES_SUCCESS:
      return {
        ...state,
        isUpdateSuccess: true,
        response: action.payload,
      };

    case UPDATE_DOCUMENT_STATUSES_FAILURE:
      return {
        ...state,
        isUpdateSuccess: false,
        response: action.payload,
      };

    case UPDATE_DOCUMENT_STATUSES_RESET:
      return initialState;

    default:
      return state;
  }
};
